var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo && _vm.$company
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": true,
          },
          on: {
            "update:active": [
              function ($event) {
                _vm.isActive = $event
              },
              function ($event) {
                return _vm.close()
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-image pt-4" }, [
              _c("figure", { staticClass: "image" }, [
                _c("img", {
                  staticStyle: { "max-height": "5rem" },
                  attrs: { src: _vm.logoImgPath },
                }),
              ]),
            ]),
            _c("div", { staticClass: "is-divider mb-0" }),
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  " Version: " +
                    _vm._s(
                      _vm.latestVersion
                        ? _vm.latestVersion.version
                        : "Not available"
                    )
                ),
                _c("br"),
                _vm._v(" Commit Hash: " + _vm._s(_vm.commitHash)),
                _c("br"),
                _vm._v(
                  " Build Date: " +
                    _vm._s(
                      _vm.$filters.formatDateTimeLocale(
                        _vm.timeStamp,
                        _vm.$userInfo.locale
                      )
                    )
                ),
                _c("br"),
                _vm._v(" Instance Name: " + _vm._s(_vm.instanceName) + " "),
                _c("div", { staticClass: "is-divider" }),
                _c("span", [
                  _vm._v("Licence Expiry: " + _vm._s(_vm.expiryDate)),
                ]),
                _c("div", { staticClass: "is-divider" }),
                _c(
                  "div",
                  { staticClass: "field is-grouped is-grouped-multiline" },
                  [
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-dark" }, [
                          _vm._v("nodejs"),
                        ]),
                        _c("span", { staticClass: "tag is-primary" }, [
                          _vm._v(_vm._s(_vm.nodeVersion)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-dark" }, [
                          _vm._v("npm"),
                        ]),
                        _c("span", { staticClass: "tag is-gold" }, [
                          _vm._v(_vm._s(_vm.npmVersion)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-dark" }, [
                          _vm._v("vuejs"),
                        ]),
                        _c("span", { staticClass: "tag is-success" }, [
                          _vm._v(_vm._s(_vm.vueVersion)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-dark" }, [
                          _vm._v("bulma"),
                        ]),
                        _c("span", { staticClass: "tag is-turquoise" }, [
                          _vm._v(_vm._s(_vm.bulmaVersion)),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "card-content" }, [
              _c("header", { staticClass: "card-header mb-1" }, [
                _c("p", { staticClass: "card-header-title" }, [
                  _vm._v(" Release Notes "),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "content is-size-7 release-notes-content" },
                [
                  _vm._l(_vm.releases, function (release, index) {
                    return [
                      _c("div", { key: index }, [
                        _c(
                          "span",
                          { staticClass: "has-text-weight-bold is-underlined" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateLocale(
                                  release.date,
                                  _vm.$user.info.locale
                                )
                              ) +
                                " - " +
                                _vm._s(release.title)
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "pb-4" },
                          _vm._l(release.notes, function (note, noteIndex) {
                            return _c("li", { key: noteIndex }, [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(note) },
                              }),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }